import * as Immutable from 'immutable';
import * as t from 'io-ts';

import { Action, ImmutableInterface } from '../../../types/';

export interface TeamOptionsAction {
  country: any;
  university: any;
  members: any;
  name: any;
  data: any;
}

export interface BaseTeamOptionsStore {
  countryOptions: Immutable.Map<string, string>;
  universityOptions: Immutable.Map<string, string>;
  countryOptionsList: Immutable.List<Immutable.Map<string, string>>;
  universityOptionsList: Immutable.List<Immutable.Map<string, string>>;
  countryRequired: boolean;
  universityRequired: boolean;
  minRequiredMembers: number;
  maxRequiredMembers: number;
  isFetching: boolean;
  maxNameLength: number;
  isUniversityReadOnly: boolean;
  isCountryReadOnly: boolean;
  isMembersReadOnly: boolean;
}

export type TeamOptionsStore = ImmutableInterface<BaseTeamOptionsStore>;
export type TeamOptionsActionType = Action<TeamOptionsAction>;

export const TeamOptionsStructure = t.interface({
  actions: t.interface({
    GET: t.interface({
      members: t.interface({
        minLength: t.number,
        maxLength: t.number,
      }),
    }),
  }),
});
